module.exports = __webpack_public_path__ + "img/enseignement-catholique.7918dec.png";